import {
  AuditTrailRecord,
  DrugExpiryRecord,
  FinancialRecord,
  StockLevelRecord,
} from "./data";
import { StatsCard } from "../stats/subs/statCard";
import Tab2 from "@/common/components/Tab/Tab2";
import { useState } from "react";
import useQuery from "@/hooks/useQuery";
import { Report_monitoringStats } from "@/common/constants";
import {
  greenWallet,
  orangeCoin,
  purpleChartArrow,
  yellowCoins,
} from "@/common/components/icons/svg-icons";
import { formatCurrency } from "@/common/components/utilities/formatCurrency";

export default function ReportMonitoring() {
  const { data: StatData } = useQuery(Report_monitoringStats);
  const [currentTab, setCurrentTab] = useState("Stock Level Report");

  //Tab items...
  const tabs = [
    {
      title: "Stock Level Report",
      component: <StockLevelRecord />,
    },
    {
      title: "Expired Drugs Report",
      component: <DrugExpiryRecord />,
    },
    {
      title: "Financial Report",
      component: <FinancialRecord />,
    },
    {
      title: "Audit Trail",
      component: <AuditTrailRecord />,
    },
  ];

  const financeStatsCards = [
    {
      id: 1,
      name: "DRF Balance",
      value: formatCurrency(StatData?.drf_balance),
      icon: greenWallet,
      color: "#43A047",
    },
    {
      id: 2,
      name: "Recent Fund Allocation",
      value: formatCurrency(StatData?.recent_fund_allocations),
      icon: yellowCoins,
      color: "#7E57C2",
      Description: "tesing",
    },
    {
      id: 3,
      name: "Total Allocations",
      value: formatCurrency(StatData?.total_allocations),
      icon: purpleChartArrow,
      color: "#673AB7",
    },
    {
      id: 4,
      name: "Total Request Submitted",
      value: StatData?.total_requests_submitted,
      icon: orangeCoin,
      color: "#FFB300",
    },
  ];
  return (
    <>
      <div className="w-full h-full flex flex-col gap-3 mt-1 ">
        <div className="w-full p-5">
          <div className="grid sm:grid-cols-4 md:grid-cols-4 grid-cols-1 p-2 gap-5">
            {financeStatsCards?.map((card) => (
              <StatsCard
                color={card?.color}
                icon={card?.icon}
                value={card?.value}
                title={card?.name}
              />
            ))}
          </div>
        </div>
        <div className="w-full p-5">
          <Tab2
            tabs={tabs}
            currentTab={currentTab}
            onTabClick={(title) => setCurrentTab(title)}
          />

          <div className="flex justify-end mx-5"></div>
        </div>
      </div>
    </>
  );
}
